export default __webpack_public_path__ + "static/media/img-crop.5792012f.svg";